import React from 'react';

export interface FieldsetProps {
  legend: string;
  legendSize?: 'default' | 'large';
  hint?: string;
  error?: string;
  horizontal?: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * KERN Fieldset Component
 *
 * Usage:
 * <Fieldset legend="Ansprechpartner">
 *   <Input label="Vorname" />
 *   <Input label="Nachname" />
 * </Fieldset>
 */
export function Fieldset({
  legend,
  legendSize = 'default',
  hint,
  error,
  horizontal = false,
  children,
  className = '',
}: FieldsetProps) {
  const fieldsetClasses = ['kern-fieldset', error && 'kern-fieldset--error', className]
    .filter(Boolean)
    .join(' ');

  const bodyClasses = ['kern-fieldset__body', horizontal && 'kern-fieldset__body--horizontal']
    .filter(Boolean)
    .join(' ');

  const legendClasses = ['kern-label', legendSize === 'large' && 'kern-label--large']
    .filter(Boolean)
    .join(' ');

  return (
    <fieldset className={fieldsetClasses}>
      <legend className={legendClasses}>{legend}</legend>
      {hint && (
        <div className="kern-hint" id="hint-text">
          {hint}
        </div>
      )}
      <div className={bodyClasses}>{children}</div>
      {error && (
        <p className="kern-error" id="kern-error" role="alert">
          <span className="kern-icon kern-icon--danger" aria-hidden="true" />
          <span className="kern-body">{error}</span>
        </p>
      )}
    </fieldset>
  );
}

export default Fieldset;
